import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QuizIcon(props: IconProps) {
    return <Icon {...props} iconKey={"quiz"}/>
}
